<button
  #anchor
  class="colored-text auth-link-bt espace-client-class"
  kendoButton
  [primary]="true"
  [icon]="'user'"
  (click)="show = !show"
>
  Espace client
</button>
<kendo-popup #popup [anchor]="anchor" class="signin-popup primary-border small-margin" *ngIf="show">
  <ags-connexion [landingRoute]="landingRoute" [popupMode]="true" (popupLeave)="toggle(false)"></ags-connexion>
</kendo-popup>
